import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 100",
  preserveAspectRatio: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "elementor-shape-fill",
  d: "M790.5 93.1c-59.3-5.3-116.8-18-192.6-50-29.6-12.7-76.9-31-100.5-35.9-23.6-4.9-52.6-7.8-75.5-5.3-10.2 1.1-22.6 1.4-50.1 7.4-27.2 6.3-58.2 16.6-79.4 24.7-41.3 15.9-94.9 21.9-134 22.6C72 58.2 0 25.8 0 25.8V100h1000V65.3S948.5 84.7 893.8 91c-54.3 6-79.7 4.2-103.3 2.1z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }